$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");

  if (p === "credit_orders") {
    $("select[name=customer-select]").select2({
      theme: "bootstrap4",
    });

    let event_id = $("body").attr("event_id");
    let orderBy = "date";
    let orderByDirection = "asc";
    let searchString = "";
    let startDate = $('#start-date').val();
    let endDate = $('#end-date').val();
    let customer_id;
    let isArchiveView = 0;

    $(document).on("click", "#order-delete-btn", function () {
      const creditOrderId = $(this).attr("data-delete-id");
      $("#delete-credit-order-confirm").attr("data-delete-id", creditOrderId);
    });


    $(document).on("change", "#archiveSwitch", function () {
        if ($(this).is(":checked")) {
            isArchiveView = 1;
            $('#send-invoices').addClass("d-none-custom");
        } else {
            isArchiveView = 0;
            $('#send-invoices').removeClass("d-none-custom");
        }

        getCreditOrder(
            event_id,
            searchString,
            startDate,
            endDate,
            customer_id,
            isArchiveView,
            orderBy,
            orderByDirection
        )
    })

    $(document).on("click", "#delete-credit-order-confirm", function () {
      const creditOrderIdToDelete = $(this).attr("data-delete-id");
      searchString = $("#search_string").val();
      startDate = $("#start-date").val();
      endDate = $("#end-date").val();
      customer_id = $("#customer-select").val();

      if (!creditOrderIdToDelete) return;

      $.ajax({
        type: "POST",
        url: "/api/v1/private/credit-order/delete",
        data: {
          order_id: creditOrderIdToDelete,
        },
      })
        .done(function (data) {
          if (data.success) {
            $("#credit-order-list-view").empty();
            $("#credit-order-list-view").html(data.html);
            $("#creditOrderDeleteConfirmationModal").modal("hide");
            popupAlert();
            $(".modal-backdrop").remove();
            $(".invoice-status-col").each(function() {
              if (!$(this).hasClass('d-none')) {
                  $(this).addClass("d-none");
              }
            });
            getCreditOrder(
              event_id,
              searchString,
              startDate,
              endDate,
              customer_id,
              isArchiveView,
              orderBy,
              orderByDirection
            );
          }
        })
        .fail(function (data) {
          if (data.responseJSON.redirect_url) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (data.error) {
            return alert(data.error);
          }
        });
    });

    $(document).on("submit", "#credit-order-search-form", function (e) {
      e.preventDefault();
      searchString = $("#search_string").val();
      startDate = $("#start-date").val();
      endDate = $("#end-date").val();
      customer_id = $("#customer-select").val();
      $(".invoice-status-col").each(function() {
        if (!$(this).hasClass('d-none')) {
            $(this).addClass("d-none");
        }
      })
      getCreditOrder(
        event_id,
        searchString,
        startDate,
        endDate,
        customer_id,
        isArchiveView,
        orderBy,
        orderByDirection
      );
    });

    $(document).on("change", "#start-date", function (e) {
      e.preventDefault();
      searchString = $("#search_string").val();
      startDate = $(this).val();
      endDate = $("#end-date").val();
      customer_id = $("#customer-select").val();

      $(".invoice-status-col").each(function() {
        if (!$(this).hasClass('d-none')) {
            $(this).addClass("d-none");
        }
      });

      getCreditOrder(
        event_id,
        searchString,
        startDate,
        endDate,
        customer_id,
        isArchiveView,
        orderBy,
        orderByDirection
      );
    });

    $(document).on("change", "#end-date", function (e) {
      e.preventDefault();
      searchString = $("#search_string").val();
      startDate = $("#start-date").val();
      endDate = $(this).val();
      customer_id = $("#customer-select").val();

      $(".invoice-status-col").each(function() {
        if (!$(this).hasClass('d-none')) {
            $(this).addClass("d-none");
        }
      });

      getCreditOrder(
        event_id,
        searchString,
        startDate,
        endDate,
        customer_id,
        isArchiveView,
        orderBy,
        orderByDirection
      );
    });

    $(document).on("change", "#customer-select", function (e) {
      e.preventDefault();
      searchString = $("#search_string").val();
      startDate = $("#start-date").val();
      endDate = $("#end-date").val();
      customer_id = $(this).val();

      $(".invoice-status-col").each(function() {
        if (!$(this).hasClass('d-none')) {
            $(this).addClass("d-none");
        }
      });

      getCreditOrder(
        event_id,
        searchString,
        startDate,
        endDate,
        customer_id,
        isArchiveView,
        orderBy,
        orderByDirection
      );
    });

    $(document).on("click", ".sort", function (e) {
      e.preventDefault();
      searchString = $("#search_string").val();
      startDate = $("#start-date").val();
      endDate = $("#end-date").val();
      customer_id = $("#customer-select").val();
      orderBy = $(this).attr("data-order-by");
      orderByDirection = $(this).attr("data-order-by-direction");

      $(".invoice-status-col").each(function() {
        if (!$(this).hasClass('d-none')) {
            $(this).addClass("d-none");
        }
      });

      getCreditOrder(
        event_id,
        searchString,
        startDate,
        endDate,
        customer_id,
        isArchiveView,
        orderBy,
        orderByDirection
      );
    });

    $(document).on("click", ".send-invoice-btn", function (e) {
      e.preventDefault();
      const button = $(this);
      button.prop("disabled", true);
      const buttonText = $(this).text();
      $(this).empty();
      $(this).append('<div class="loader"></div>');
      const creditOrderId = $(this).attr("data-order-id");
      $.ajax({
        type: "POST",
        url: "/api/v1/private/credit-order/send-invoice",
        data: {
          order_id: creditOrderId,
        },
      })
        .done(function (data) {
          if (data.message) {
            showToast({
                title: "Suksess!",
                message: data.message,
                type: 'success',
                duration: 5000
            })
            button.closest("tr").fadeOut(500, function () {
                $(this).remove();
                getCreditOrder(event_id, searchString, startDate, endDate, customer_id, isArchiveView, orderBy, orderByDirection)
            })
          }
        })
        .fail(function (data) {
            if (data.responseJSON && data.responseJSON.error_message) {
                showToast({
                    title: "Feil!",
                    message: data.responseJSON.error_message,
                    type: 'error',
                    duration: 5000
                });
            } else {
                showToast({
                    title: "Feil!",
                    message: "Uventet feil oppstod. Prøv igjen senere.",
                    type: 'error',
                    duration: 5000
                });
            }
        })
        .always(function () {
            button.html(buttonText);
            button.prop("disabled", false);
        })
    });

    $(document).on("click", ".send-invoices-confirm", function (e) {
      e.preventDefault();

      startDate = $("#start-date").val();
      endDate = $("#end-date").val();
      customer_id = $("#customer-select").val();
      let type = $(this).attr("data-type");

      let sendInvoicesBtn = $("#send-invoices");
      let sendInvoicesBtnText = sendInvoicesBtn.text();
      sendInvoicesBtn.attr("disabled", true);
      sendInvoicesBtn.empty();
      sendInvoicesBtn.append('<div class="loader"></div>');

      $(".order-product-delete-btn").prop("disabled", true);
      $(".send-invoice-btn").prop("disabled", true);

      $("#send-invoices-modal").modal("hide");
      $("#credit-order-error-container").html("");

      $(".invoice-status-col").removeClass("d-none")
      $(".invoice-status.loading").removeClass("d-none")

      if (!$(".invoice-status.failed").hasClass('d-none')) {
        $(".invoice-status.failed").addClass("d-none");
      }

      $.ajax({
        type: "POST",
        url: "/api/v1/private/credit-order/send-invoices",
        data: {
          event_id,
          search_string: searchString,
          start_date: startDate,
          end_date: endDate,
          customer_id,
          order_by: orderBy,
          order_by_direction: orderByDirection,
          type
        },
      })
        .done(function (data) {
          sendInvoicesBtn.empty();
          sendInvoicesBtn.text(sendInvoicesBtnText);
          sendInvoicesBtn.removeAttr("disabled");

          if (data.invoices && data.invoices.length) {
            data.invoices.forEach(function (invoice) {
                if (invoice.status === "success") {
                    const tr = $("#credit-order-" + invoice.order_id);
                    tr.addClass("success");
                    if ($("#status-success-" + invoice.order_id).hasClass('d-none')) {
                        $("#status-success-" + invoice.order_id).removeClass("d-none");
                    }

                    if (!$("#status-loading-" + invoice.order_id).hasClass('d-none')) {
                        $("#status-loading-" + invoice.order_id).addClass("d-none");
                    }

                    if (!$("#status-failed-" + invoice.order_id).hasClass('d-none')) {
                        $("#status-failed-" + invoice.order_id).addClass("d-none");
                    }

                    tr.fadeOut(1500, function() {
                        tr.remove();
                    });
                } else if (invoice.status === "failed") {
                    const tr = $("#credit-order-" + invoice.order_id);
                    tr.addClass("failed");
                    if ($("#status-failed-" + invoice.order_id).hasClass('d-none')) {
                        $("#status-failed-" + invoice.order_id).removeClass("d-none");

                        $("#status-failed-" + invoice.order_id + " .status-text").text(invoice.message);
                    }

                    if (!$("#status-success-" + invoice.order_id).hasClass('d-none')) {
                        $("#status-success-" + invoice.order_id).addClass("d-none");
                    }

                    if (!$("#status-loading-" + invoice.order_id).hasClass('d-none')) {
                        $("#status-loading-" + invoice.order_id).addClass("d-none");
                    }
                }
            });
            setTimeout(function() {
                if ($("#credit-order-list-tbody tr").length == 1) {
                    $(".invoice-status-col").each(function() {
                        if (!$(this).hasClass('d-none')) {
                            $(this).addClass("d-none");
                        }
                    });
                }

                if (parseFloat(data.totalPriceExVat) && parseFloat(data.totalPriceIncVat)) {
                    $("#total-price-ex-vat").text(data.totalPriceExVat);
                    $("#total-price-inc-vat").text(data.totalPriceIncVat);
                }
            }, 1500);
          } else {
            getCreditOrder(event_id, searchString, startDate, endDate, customer_id, isArchiveView, orderBy, orderByDirection)
          }
        })
        .fail(function (data) {
          sendInvoicesBtn.empty();
          sendInvoicesBtn.text(sendInvoicesBtnText);
          sendInvoicesBtn.removeAttr("disabled");

            if (data.responseJSON && data.responseJSON.error_message) {
                $("#credit-order-error-container").html(getAlertHtml(data.responseJSON.error_message, "danger"));
            } else if (data.responseText) {
                const {error_message} = JSON.parse(data.responseText);
                if (error_message) {
                    $("#credit-order-error-container").html(getAlertHtml(error_message, "danger"));
                }
            }

            $(".invoice-status-col").addClass("d-none")
            $(".invoice-status").addClass("d-none")
        })
        .always(function () {
            $(".order-product-delete-btn").prop("disabled", false);
            $(".send-invoice-btn").prop("disabled", false);
        });
    });


    function getCreditOrder(
      event_id,
      searchString = "",
      startDate,
      endDate,
      customer_id = 0,
      isArchiveView = 0,
      orderBy,
      orderByDirection
    ) {
      $.ajax({
        type: "POST",
        url: "/api/v1/private/credit-order/search",
        data: {
          event_id,
          search_string: searchString,
          start_date: startDate,
          end_date: endDate,
          customer_id,
          archive: isArchiveView,
          order_by: orderBy,
          order_by_direction: orderByDirection,
        },
      })
        .done(function (data) {
          if (data.html) {
            $("#credit-order-list-view").empty();
            $("#credit-order-list-view").append(data.html);
            const pathName = window.location.pathname;
            let downloadUrl = pathName + "/download?";
            if (customer_id !== 0) {
              downloadUrl += "customer_id=" + customer_id + "&";
            }

            if (startDate !== "") {
              downloadUrl += "start_date=" + startDate + "&";
            }

            if (endDate !== "") {
              downloadUrl += "end_date=" + endDate;
            }

            if (isArchiveView) {
              downloadUrl +=
                (downloadUrl.includes("?") ? "&" : "?") + "archive=1";
            }

            if (data.send_invoices_confirmation_modal) {
              $("#send-invoices-confirmation-container").html(data.send_invoices_confirmation_modal);
            }

            $("#credit_order_download").attr("href", downloadUrl);

          if (data.creditOrderListCount) {
              const excelExportBtn = $('#credit_order_download');  
              excelExportBtn.css('opacity',"1")
              excelExportBtn.css('pointer-events',"auto")
          } else{
            const excelExportBtn = $('#credit_order_download');  
            excelExportBtn.css('opacity',"0.5")
              excelExportBtn.css('pointer-events',"none")
            }
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.redirect_url !== undefined &&
            data.responseJSON.redirect_url !== null
          ) {
            document.location.href = data.responseJSON.redirect_url;
          }
        });
    }
  }
});
